import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";

// Platform Pages
import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import CustomerLoginPage from "./pages/CustomerLoginPage";
import CustomerRegisterPage from "./pages/CustomerRegisterPage";
import SearchPage from "./pages/SearchPage";
import TermsPage from "./pages/TermsPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";

// Dashboard Pages
import DashboardLayout from "./layouts/DashboardLayout";
import DashboardHome from "./pages/dashboard/DashboardHome";
import PropertiesPage from "./pages/dashboard/PropertiesPage";
import PropertyFormPage from "./pages/dashboard/PropertyFormPage";
import EnquiriesPage from "./pages/dashboard/EnquiriesPage";
import AnalyticsPage from "./pages/dashboard/AnalyticsPage";
import SettingsPage from "./pages/dashboard/SettingsPage";
import SubscriptionPage from "./pages/dashboard/SubscriptionPage";
import TicketsPage from "./pages/dashboard/TicketsPage";
import TicketDetail from "./pages/dashboard/TicketDetail";
import TeamPage from "./pages/dashboard/TeamPage";
import AboutPageEditor from "./pages/dashboard/AboutPageEditor";

// Customer Pages
import CustomerLayout from "./layouts/CustomerLayout";
import CustomerFavorites from "./pages/customer/CustomerFavorites";
import CustomerTickets from "./pages/customer/CustomerTickets";
import CustomerProfile from "./pages/customer/CustomerProfile";

// Admin Pages
import AdminLayout from "./layouts/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminAgencies from "./pages/admin/AdminAgencies";
import AdminCustomers from "./pages/admin/AdminCustomers";
import AdminRevenue from "./pages/admin/AdminRevenue";
import AdminSubscriptions from "./pages/admin/AdminSubscriptions";
import AdminOffers from "./pages/admin/AdminOffers";
import AdminNotifications from "./pages/admin/AdminNotifications";
import AdminReports from "./pages/admin/AdminReports";
import AdminTickets from "./pages/admin/AdminTickets";
import AdminProperties from "./pages/admin/AdminProperties";

// Agency Public Pages
import AgencyLayout from "./layouts/AgencyLayout";
import AgencyHome from "./pages/agency/AgencyHome";
import AgencyProperties from "./pages/agency/AgencyProperties";
import AgencyPropertyDetail from "./pages/agency/AgencyPropertyDetail";
import AgencyAbout from "./pages/agency/AgencyAbout";
import AgencyContact from "./pages/agency/AgencyContact";
import AgencyReports from "./pages/agency/AgencyReports";

import DomainRouter from "./components/DomainRouter";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <DomainRouter>
          <Routes>
            {/* Platform Landing */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/customer/login" element={<CustomerLoginPage />} />
            <Route path="/customer/register" element={<CustomerRegisterPage />} />
            <Route path="/search" element={<SearchPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy" element={<PrivacyPolicyPage />} />
            <Route path="/payment/success" element={<PaymentSuccessPage />} />

            {/* Agency Dashboard (Protected) */}
            <Route path="/dashboard" element={<DashboardLayout />}>
              <Route index element={<DashboardHome />} />
              <Route path="properties" element={<PropertiesPage />} />
              <Route path="properties/new" element={<PropertyFormPage />} />
              <Route path="properties/:id/edit" element={<PropertyFormPage />} />
              <Route path="enquiries" element={<EnquiriesPage />} />
              <Route path="analytics" element={<AnalyticsPage />} />
              <Route path="settings" element={<SettingsPage />} />
              <Route path="subscription" element={<SubscriptionPage />} />
              <Route path="tickets" element={<TicketsPage />} />
              <Route path="tickets/:ticketId" element={<TicketDetail />} />
              <Route path="team" element={<TeamPage />} />
              <Route path="about-editor" element={<AboutPageEditor />} />
              <Route path="reports" element={<AgencyReports />} />
            </Route>

            {/* Customer Dashboard (Protected) */}
            <Route path="/customer" element={<CustomerLayout />}>
              <Route path="favorites" element={<CustomerFavorites />} />
              <Route path="tickets" element={<CustomerTickets />} />
              <Route path="tickets/:ticketId" element={<TicketDetail />} />
              <Route path="profile" element={<CustomerProfile />} />
            </Route>

            {/* Admin Panel (Protected) */}
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="agencies" element={<AdminAgencies />} />
              <Route path="customers" element={<AdminCustomers />} />
              <Route path="revenue" element={<AdminRevenue />} />
              <Route path="subscriptions" element={<AdminSubscriptions />} />
              <Route path="offers" element={<AdminOffers />} />
              <Route path="notifications" element={<AdminNotifications />} />
              <Route path="notifications" element={<AdminNotifications />} />
              <Route path="reports" element={<AdminReports />} />
              <Route path="properties" element={<AdminProperties />} />
              <Route path="tickets" element={<AdminTickets />} />
              <Route path="tickets/:ticketId" element={<TicketDetail />} />
            </Route>

            {/* Agency Public Website */}
            <Route path="/agency/:slug" element={<AgencyLayout />}>
              <Route index element={<AgencyHome />} />
              <Route path="properties" element={<AgencyProperties />} />
              <Route path="property/:propertyId" element={<AgencyPropertyDetail />} />
              <Route path="about" element={<AgencyAbout />} />
              <Route path="contact" element={<AgencyContact />} />
            </Route>
          </Routes>
        </DomainRouter>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
